export const data9_8_2_default = [{
   purchase_item:"",
   unit:"",
   kitchen:"",
   quantity:0,
   average_unit_price:0,
   total_amount:0,
   total_purchase_percent:0,
},{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"",
    unit:"",
    kitchen:"",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"Top 15 Total 前15位合计",
    unit:"-",
    kitchen:"-",
    quantity:0,
    average_unit_price:0,
    total_amount:0,
    total_purchase_percent:0,
 },{
    purchase_item:"Total Food Purchase 食品采购总额",
    unit:"-",
    kitchen:"-",
    quantity:"-",
    average_unit_price:"-",
    total_amount:0,
    total_purchase_percent:"-",
 },{
    purchase_item:"Top 15 Vs. Total Purchase 前15位采购占总额比率",
    unit:"-",
    kitchen:"-",
    quantity:"-",
    average_unit_price:"-",
    total_amount:0,
    total_purchase_percent:"-",
 }];


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-8/9-8-2/data.js